import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import seattle from "../assets/images/seattle2.jpg";

function Background(props) {
  return (
    <Container className="m-3">
      <Row>
        <Col>
          <h3>Background</h3>
          <p style={{ fontSize: "1.2rem" }}>
            I spent my first 18 years living near Seattle, Washington. I studied
            Information Systems Management at McGill in Montreal, Quebec. During
            the lockdown I found a new passion for development, and thus spent
            months learning as much as I could about software engineering and
            development. I've always loved solving problems and puzzles, and
            can't wait to tackle more. If you are looking for someone who enjoys
            challenges, don't hesitate to contact me.
          </p>
        </Col>
        <Col className="d-none d-md-block">
          <Image src={seattle} fluid rounded />
        </Col>
      </Row>
      <hr />
    </Container>
  );
}

export default Background;
